module.exports = __webpack_public_path__ + "static/img/shenzhen.a19880d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shenzhen.jpg
// module id = cyqr
// module chunks = 1